import { AppSpan, AppText, Button, CustomContainer, FlexRow, GridContainer, ScreenTitle } from "src/style"
import { SidePopupLayout } from "src/component"
import { FaRegMoneyBillAlt } from "react-icons/fa"
import { moneyFormat } from "src/utils/utility"
import AppInfoContext from "src/provider/state-manager/appInfoProvider";
import { useContext } from "react";

export const LoanConfirmation: React.FC<any> = ({view, next, back, close, creditAssessment, networkProvider}:{view:View,next: ()=>void, back: ()=>void, close: ()=>void, creditAssessment: CreditAssessment, networkProvider:any}) => {
    const {info: { institutionData }} = useContext(AppInfoContext);

    return (
        <SidePopupLayout close={close}>
            <ScreenTitle textSize="2.2" fontWeight="700">Confirmation</ScreenTitle>
            <CustomContainer topMargin="2.5">
                <AppSpan>See below Loan confirmation</AppSpan>
                <GridContainer
                    bgColor="#E7F6F5" minHeight="6.2" padding="1" topMargin="2"
                    leftPadding="2" rightPadding="2" radius="0.8" 
                >
                    <FlexRow>
                        <FaRegMoneyBillAlt style={{color: '#0D968F', fontSize: '2rem'}} />
                        <AppText textSize="1.2" color="#0A756F" leftMargin="1">
                            Maximum Loan Amount: <AppSpan textSize="1.2" color="#0A756F" fontWeight="600">{moneyFormat(creditAssessment.approvedLoanAmount, true,institutionData?.defaultCurrency)}</AppSpan>
                        </AppText>
                    </FlexRow>
                </GridContainer>
                <CustomContainer
                    minHeight="15.0" borderColor="#EAECF0" padding="2" radius="0.8" topMargin="2"
                >
                    <FlexRow justifyContent="space-between" gap="1.5" wrap="wrap">
                        <GridContainer width="auto" sizeUnit="" alignItems="start">
                            <AppSpan>Interest Rate</AppSpan>
                        </GridContainer>
                        <GridContainer width="auto" sizeUnit="" alignItems="end">
                            <AppText fontWeight="700" color="#0D968F" fontFamily="Gilmer-Bold">{creditAssessment.interestRate}%</AppText>
                        </GridContainer>
                    </FlexRow>
                    <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                        <GridContainer width="auto" sizeUnit="" alignItems="start">
                            <AppSpan>Tenure</AppSpan>
                        </GridContainer>
                        <GridContainer width="auto" sizeUnit="" alignItems="end">
                            <AppText fontWeight="700" color="#0D968F" fontFamily="Gilmer-Bold">{creditAssessment.loanTenure} days</AppText>
                        </GridContainer>
                    </FlexRow>
                    <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                        <GridContainer width="auto" sizeUnit="" alignItems="start">
                            <AppSpan>Telco</AppSpan>
                        </GridContainer>
                        <GridContainer width="auto" sizeUnit="" alignItems="end">
                            <AppText fontWeight="700" color="#0D968F" fontFamily="Gilmer-Bold">{networkProvider}</AppText>
                        </GridContainer>
                    </FlexRow>
                </CustomContainer>
                <FlexRow justifyContent='flex-end' gap="1.5" topMargin="2.5">
                    <Button 
                        width='6.7' height='4' bgColor="#ffffff"
                        borderColor='#D0D5DD' hoverBgColor='#ffffff' 
                        hoverColor='#0D968F' titleSize='1.4' color="#344054"
                        onClick={back}
                    >
                        Back
                    </Button>
                    <Button 
                        width='8.7' height='4' 
                        borderColor='#0D968F' hoverBgColor='#ffffff' 
                        hoverColor='#0D968F' titleSize='1.4'
                        onClick={next}
                    >
                        Confirm
                    </Button>
                </FlexRow>
            </CustomContainer>
        </SidePopupLayout>
    )
}
type View = 'new-overdraft' | 'new-loan' | 'loan-details' | 'terms_conditions' | 'reviewing_eligibility' | ''

type CreditAssessment = {
    approvedLoanAmount: number
    interestRate: number
    loanOffer: string
    loanReference: string
    loanTenure: number
}